import {
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  AccordionActions,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAuth } from "../../context/GlobalState";
import { useEffect, useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import CheckoutProduct from "../checkout/CheckoutProduct";
import { getBasketTotal } from "../../context/AppReducer";
import CurrencyFormat from "react-currency-format";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { doc,  setDoc } from "firebase/firestore";
export default function Payment() {
  const [location, setLocation] = useState({ country: "", region: "" });
  const { basket, user, dispatch } = useAuth();

    const [clientSecret, setClientSecret] = useState();
    const [error, setError] = useState(null);

    const [disabled, setDisabled] = useState(true);
    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState(null);

    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();


    useEffect(() => {
      const getClientSecret = async () => {
        const response = await fetch(
          `http://127.0.0.1:5001/n-ce38f/us-central1/api/payments/create?total=${getBasketTotal(basket) * 100}`,
          {method:"post",
          }
          
        )
        const data = await response.json();
        
        setClientSecret(data.clientSecret);
        
        return data;
      };
      getClientSecret();
    }, [basket]);


    const handleSubmit = async (e) => {
      e.preventDefault();
      setProcessing(true);

      const payload = await stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        })
        .then(({ paymentIntent }) => {
          
            let ref = doc(db, "users", user?.uid, "orders", paymentIntent?.id);            
              setDoc(ref ,{
              basket: basket,
              amount: paymentIntent?.amount ,
              created: paymentIntent?.created ,
            });     
        
          setSucceeded(true);
          setError(null);
          setProcessing(false);
          dispatch({
            type: "EMPTY_BASKET",
          });
          navigate("/orders", { replace: true });
      });

      console.log(payload);
    };


  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const res =
            await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}
                &lon=${longitude}`);

          const data = await res.json();
          setLocation({
            country: data.address.country,
            region: data.address.state || data.address.country,
          });
        } catch (error) {
          setError(error.message);
        }
      });
    } else {
      setError("Cant get the geo");
    }
  }, []);


  const handleChange = (e)=> {
    setDisabled(e.empty);
  setError(error ? error.message : "");
  }

  return (


    <Box>
      <Typography variant="h5" textAlign={"center"} bgcolor={"#cacaca"} py={2}
      onClick={()=> navigate("/checkout")}
      sx={{cursor:"pointer"}}
      >
        Checkout - ({basket?.length} items)
      </Typography>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="h6" variant="h6" fontWeight={600}>
            Delivery Address
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {user ? user.email : "You must Create Account or sign in"}
          </Typography>

          <Typography>
            {user?
            location.country ? (
              <p>
                {location.country},{location.region}
              </p>
            ) : (
              error && <p>error : {error}</p>
            ): "Location Not Found"
          }
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="h6" variant="h6" fontWeight={600}>
            Review items and delivery ({basket?.length})
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ overflow: "scroll", height: "30vh" }}>
          <CheckoutProduct />
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography component="h6" variant="h6" fontWeight={600}>
            Payment Method
          </Typography>
        </AccordionSummary>
        <AccordionDetails>


        </AccordionDetails>
        <AccordionActions
          sx={{ textAlign: "center", display: "block", width: "98%" }}
        >
          <Box component={"form"} onClick={handleSubmit}>

          <CardElement onChange={handleChange} />



            <CurrencyFormat
              renderText={(value) => (
                <h3 style={{ textAlign: "left", marginLeft: 10 }}>
                  Order Total : {value}
                </h3>
              )}
              decimalScale={2}
              value={getBasketTotal(basket)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />

            <Button
            type="submit"
              variant="contained"
              disabled={processing || disabled || succeeded}
              sx={{ bgcolor: "#fcd115", color: "#222", width: "90%" }}
            >
              <span>{processing ? "Processing" : "Buy Now"}</span>
            </Button>
            {error && <div>{error}</div>}
          </Box>
        </AccordionActions>
      </Accordion>
    </Box>
  );
}
